<template>
  <section class="info-users">
    <div class="wrap">
      <h2 class="section-title">Información para usuarios:</h2>
      <div class="cards" ref="carousel" @scroll="handleScroll">
        <article class="card" v-for="(item, index) in cardsData" :key="index"
          :class="{ 'card-selected': isSelectedCard(item) }" @click="handleCardClick(item)">
          <div class="card-img">
            <img :src="item.img" :alt="item.shortTitle" />
          </div>
          <div class="card-body">
            <h3>{{ item.shortTitle }}</h3>
          </div>
        </article>
      </div>
      <div class="dots" aria-label="Indicador de carrusel">
        <span class="dot" :class="{ active: currentBlock === 0 }" @click="scrollToBlock(0)"></span>
        <span class="dot" :class="{ active: currentBlock === 1 }" @click="scrollToBlock(1)"></span>
      </div>
      <footer class="legal-footer">
        <p class="desktop-text">
          Bienestar Azteca Digital es un servicio de Banca Móvil otorgado por
          Banco Azteca, S.A., Institución de Banca Múltiple. <br>
          Todos los Derechos Reservados 2026.
        </p>
        <p class="mobile-text">
          Bienestar Azteca Digital es un servicio de Banca Móvil
          otorgado por Banco Azteca, S.A., Institución de Banca Múltiple
        </p>
        <p class="mobile-text">Todos los Derechos Reservados 2026.</p>
      </footer>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import img1 from '@/assets/images/Cuenta.png'
import img2 from '@/assets/images/menoredad.png'
import img3 from '@/assets/images/retiros.png'
import img4 from '@/assets/images/sisoymayor.png'
import img5 from '@/assets/images/datospersonales.png'
import img6 from '@/assets/images/redireccionappba.png'
import backImg1 from '@/assets/images/micuentaback.png'
import backImg2 from '@/assets/images/menorback.png'
import backImg3 from '@/assets/images/retirosback.png'
import backImg4 from '@/assets/images/sisoymayorback.png'
import backImg5 from '@/assets/images/misdatosback.png'
import backImg6 from '@/assets/images/redireccionback.png'

const AUTOPLAY_INTERVAL_MS = 20000

const B1_CUENTA_1 =
  '<strong>Tu cuenta sigue activa y vigente</strong>, si eres mayor de edad la puedes ' +
  'visualizar y gestionar en la <strong>App de Banco Azteca.</strong> Ahora tu cuenta ' +
  'Bienestar Azteca cambiará al nombre de <strong>"Avanza Banco Azteca N2"</strong> ' +
  'por lo que al ingresar a la App de Banco Azteca podrías encontrarla con este nombre.'
const B1_CUENTA_2 =
  'Este cambio de nombre en la cuenta <strong>solo aplica para cuentas "Bienestar"' +
  '</strong>, no aplica para cuentas <strong>"Bienestar jóvenes"</strong> (menores de edad).'
const B1_CUENTA_3 =
  'Para más información consulta el link ' +
  '<a href="https://www.bancoazteca.com.mx" target="_blank" ' +
  'style="color:#17A54D;font-weight:700;text-decoration:underline;">' +
  'Aviso de modificación al contrato múltiple de productos y servicios bancarios</a> ' +
  'de la página de Banco Azteca.'
const B1_CUENTA_4 =
  'La información asociada a las cuentas se <strong>mantiene resguardada</strong> ' +
  'conforme a la legislación vigente.'

const B2_SALDOS_2 =
  'Adicional, tus tutores pueden visualizarlo en este sitio Web, dando clic al botón ' +
  '<strong>"Consulta estado de cuenta y movimientos menores de edad"</strong> ' +
  'ingresando tu CURP y el correo electrónico del tutor.'
const B3_RETIRO_1 =
  'Si eres menor de edad acude a cualquier sucursal de Banco Azteca y podrás realizar ' +
  'el <strong>retiro total de tus recursos</strong>.'
const B4_MAYOR_3 =
  'Podrás realizar <strong>todas tus operaciones</strong> a través de la app de Banco ' +
  'Azteca. Si ya contabas con tarjeta física de origen, también por este medio.'
const B4_MAYOR_4 =
  'En caso de aclaraciones, podrás comunicarte a través del canal de contacto ' +
  '<strong>Línea Bienestar Azteca 55 7600 6440</strong>, acudir a una sucursal ' +
  'o a través de la app de <strong>Banco Azteca</strong>.'

const PDF_URL = 'https://d1mq21xo4bjiqa.cloudfront.net/documentos/redireccion_app_ba.pdf'
const LINK_STYLE = 'color: #17A54D; text-decoration: underline; font-weight: 700;'
const DESC_REDIRECCION =
  `Redirección a la App Banco Azteca: Paso a paso infografía. ` +
  `<a href="${PDF_URL}" target="_blank" style="${LINK_STYLE}">Descárgala aquí</a>`

const cardsData = [
  {
    title: '¿Qué pasa con mi cuenta?',
    shortTitle: '¿Qué pasa con mi cuenta?',
    img: img1, backImg: backImg1,
    bullets: [B1_CUENTA_1, B1_CUENTA_2, B1_CUENTA_3, B1_CUENTA_4]
  },
  {
    title: '¿Si soy menor de edad dónde visualizo saldos y movimientos?',
    shortTitle: '¿Si soy menor de edad donde visualizó…',
    img: img2, backImg: backImg2,
    bullets: [
      'Podrás consultar tus saldos y movimientos en sucursal.',
      B2_SALDOS_2
    ]
  },
  {
    title: '¿Si soy menor de edad cómo puedo retirar mis recursos?',
    shortTitle: '¿Si soy menor de edad cómo puedo retirar... ',
    img: img3, backImg: backImg3,
    bullets: [B3_RETIRO_1]
  },
  {
    title: 'Si soy mayor de edad ¿Qué pasa con mi dinero, apoyos o historial?',
    shortTitle: 'Sí soy mayor de edad ¿Qué pasa con mi ...?',
    img: img4, backImg: backImg4,
    bullets: [
      'Los apoyos, pagos o dispersión de recursos realizados antes del cierre ' +
      '<strong>no se ven afectados</strong>.',
      'Realiza tus <strong>consultas de movimientos y saldos</strong> en la app de Banco ' +
      'Azteca, o llamado a la línea Bienestar Azteca y en sucursales.',
      B4_MAYOR_3,
      B4_MAYOR_4
    ]
  },
  {
    title: '¿Qué pasa con mis datos personales?',
    shortTitle: '¿Qué pasa con mis datos personales?',
    img: img5, backImg: backImg5,
    bullets: [
      'Tus datos personales están protegidos conforme al ' +
      '<strong>Aviso de Privacidad de Banco Azteca</strong>.',
      'Puedes ejercer tus derechos <strong>ARCO</strong> en cualquier momento ' +
      'durante el periodo de resguardo.'
    ]
  },
  {
    title: '<strong>Redirección a la App Banco Azteca</strong>',
    shortTitle: 'Redirección a la App Banco Azteca',
    img: img6, backImg: backImg6,
    description: DESC_REDIRECCION,
    descriptionMobile: [DESC_REDIRECCION]
  }
]

const carousel = ref(null)
const currentBlock = ref(0)
const selectedCard = ref(null)
const interval = ref(null)
const emit = defineEmits(['card-click'])

const isSelectedCard = item => selectedCard.value?.shortTitle === item.shortTitle

const handleCardClick = card => {
  selectedCard.value = card
  emit('card-click', { ...card })
}

const scrollToBlock = blockIndex => {
  if (!carousel.value) return
  carousel.value.scrollTo({
    left: carousel.value.offsetWidth * blockIndex,
    behavior: 'smooth'
  })
  currentBlock.value = blockIndex
}

const handleScroll = () => {
  if (!carousel.value) return
  const isSecondBlock = carousel.value.scrollLeft > (carousel.value.offsetWidth / 2)
  if (isSecondBlock) {
    currentBlock.value = 1
  } else {
    currentBlock.value = 0
  }
}

const startAutoPlay = () => {
  interval.value = setInterval(() => {
    const nextBlock = currentBlock.value === 0 ? 1 : 0 // NOSONAR
    scrollToBlock(nextBlock)
  }, AUTOPLAY_INTERVAL_MS)
}

onMounted(() => startAutoPlay())
onUnmounted(() => clearInterval(interval.value))
</script>

<style scoped>
.info-users {
  background: #fff;
  padding: 60px 16px;
  font-family: 'Source Sans Pro', sans-serif;
}
.wrap { max-width: 1140px; margin: 0 auto; text-align: center; }
.section-title {
  font-size: 30px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 45px;
}
.cards {
  display: flex;
  gap: 30px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;
  padding: 10px 5px 35px;
}
.cards::-webkit-scrollbar { display: none; }
.card {
  flex: 0 0 calc(33.333% - 20px);
  scroll-snap-align: start;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 35px rgba(0,0,0,0.06);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;
  cursor: pointer;
  border: 3px solid transparent;
}
.card-selected {
  border: 3px solid #2196F3;
  box-shadow: 0 18px 45px rgba(33,150,243,0.3);
  animation: bounce 1.5s ease-in-out infinite;
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  25% { transform: translateY(-8px); }
  50% { transform: translateY(0); }
  75% { transform: translateY(-4px); }
}
.card-img { height: 200px; width: 100%; background: #fff; }
.card-img img { width: 100%; height: 100%; object-fit: cover; }
.card-body {
  padding: 25px 20px 40px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-body h3 {
  margin: 0;
  font-size: 21px;
  font-weight: 800;
  color: #2b2b2b;
  line-height: 1.25;
}
.card:hover:not(.card-selected) {
  transform: translateY(-4px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.15);
}
.dots { margin: 10px 0 70px; display: flex; justify-content: center; gap: 12px; }
.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e0e0e0;
  cursor: pointer;
  transition: background 0.3s ease;
}
.dot.active { background: #67b52d; }
.legal-footer { max-width: 900px; margin: 0 auto; }
.legal-footer p {
  font-size: 19px;
  color: #999999;
  line-height: 1.6;
  margin-bottom: 15px;
  font-weight: 400;
}
.legal-footer a { color: #999999; text-decoration: underline; transition: color 0.2s ease; }
.legal-footer a:hover { color: #67b52d; }
.desktop-text { display: block; }
.mobile-text { display: none; }

@media (max-width: 1024px) { .card { flex: 0 0 calc(50% - 15px); } }

@media (max-width: 768px) {
  .card { flex: 0 0 88%; }
  .section-title { font-size: 24px; }
  .card-img { height: 170px; }
  .legal-footer p { font-size: 16px; }
  .desktop-text { display: none; }
  .mobile-text {
    display: block;
    margin-bottom: 12px;
    text-align: center;
    line-height: 1.65;
  }
}
</style>